<script>
    export let fill = '#000'
</script>

<style>
    svg {
        position: absolute;
        top: 47px;
        left: 0;
        width: 414px;
        height: 174px;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 412.5 173.26"><defs>
        <style>
            .cls-1 {
                stroke-miterlimit: 10;
                stroke-width: 0.27px;
            }
        </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} class="cls-1" x="0.14" y="0.14" width="412.23" height="172.99" />
        </g>
    </g></svg>
